/* eslint-disable max-len */
import React from 'react';
import { apiPlugin, storyblokInit } from 'gatsby-source-storyblok';
import PropTypes from 'prop-types';
import AccordionItem from '../components/Storyblok/accordion/AccordionItem';
import AccordionList from '../components/Storyblok/accordion/AccordionList';
import MediaKit from '../components/Storyblok/accordion/MediaKit';
import MediaKitAccordionItem from '../components/Storyblok/accordion/MediaKitAccordionItem';
import CarouselPost from '../components/Storyblok/blogs/CarouselPost';
import FeaturedPost from '../components/Storyblok/blogs/FeaturedPost';
import Post from '../components/Storyblok/blogs/Post';
import BusinessHero from '../components/Storyblok/BusinessHero';
import BusinessPage from '../components/Storyblok/BusinessPage';
import ProductDetailSlider from '../components/Storyblok/Carousels/ProductDetailSlider';
import Slider1 from '../components/Storyblok/Carousels/Slider1';
import Slider1Item from '../components/Storyblok/Carousels/Slider1Item';
import Slider2 from '../components/Storyblok/Carousels/Slider2';
import Slider2Item from '../components/Storyblok/Carousels/Slider2Item';
import Slider3 from '../components/Storyblok/Carousels/Slider3';
import Slider3Item from '../components/Storyblok/Carousels/Slider3Item';
import Slider4 from '../components/Storyblok/Carousels/Slider4';
import Slider4Item from '../components/Storyblok/Carousels/Slider4Item';
import BusinessContact from '../components/Storyblok/contact/BusinessContact';
import Contact from '../components/Storyblok/contact/Contact';
import DefaultPage from '../components/Storyblok/DefaultPage';
import FAQ from '../components/Storyblok/FAQ/FAQ';
import Questions from '../components/Storyblok/FAQ/Questions';
import BusinessFooter from '../components/Storyblok/Footer/BusinessFooter';
import Footer from '../components/Storyblok/Footer/Footer';
import BusinessHeader from '../components/Storyblok/Header/BusinessHeader';
import Header from '../components/Storyblok/Header/Header';
import Hero from '../components/Storyblok/Hero';
import IconTextList from '../components/Storyblok/iconTextList/IconTextList';
import IconTextListItem from '../components/Storyblok/iconTextList/IconTextListItem';
import LargeImageWithTitleAndCta from '../components/Storyblok/LargeImageWithTitleAndCta';
import Section from '../components/Storyblok/layouts/Section';
import SectionHeader from '../components/Storyblok/layouts/SectionHeader';
import Newspaper from '../components/Storyblok/newspapers/Newspaper';
import Newspapers from '../components/Storyblok/newspapers/Newspapers';
import PDFViewer from '../components/Storyblok/PDFViewer';
import Policy from '../components/Storyblok/policy/Policy';
import PolicyItem from '../components/Storyblok/policy/PolicyItem';
import PostGrid from '../components/Storyblok/press/PostGrid';
import Press from '../components/Storyblok/press/Press';
import BusinessProductList from '../components/Storyblok/Product/BusinessProductList';
import BusinessProductListItem from '../components/Storyblok/Product/BusinessProductListItem';
import ProductDetailsSection from '../components/Storyblok/Product/ProductDetailsSection';
import ShopProduct from '../components/Storyblok/Product/ShopProduct';
import TwoColumnProductHighlight from '../components/Storyblok/Product/TwoColumnProductHighlight';
import PromoteCategories from '../components/Storyblok/promoteCategory/PromoteCategories';
import PromoteCategoryItem from '../components/Storyblok/promoteCategory/PromoteCategoryItem';
import SingleColumnQuote from '../components/Storyblok/SingleColumnQuote';
import SingleColumnTitleTextAccordion from '../components/Storyblok/SingleColumnTitleTextAccordion';
import SingleColumnTitleTextCta from '../components/Storyblok/SingleColumnTitleTextCta';
import Button from '../components/Storyblok/singleElements/Button';
import EmbeddedEventTime from '../components/Storyblok/singleElements/EmbeddedEventTime';
import EmbeddedImage from '../components/Storyblok/singleElements/EmbeddedImage';
import EmbeddedVideo from '../components/Storyblok/singleElements/EmbeddedVideo';
import Link from '../components/Storyblok/singleElements/Link';
import Media from '../components/Storyblok/singleElements/Media';
import RichText from '../components/Storyblok/singleElements/RichText';
import Video from '../components/Storyblok/singleElements/Video';
import BusinessSupport from '../components/Storyblok/support/BusinessSupport';
import Support from '../components/Storyblok/support/Support';
import TabItem from '../components/Storyblok/tabber/TabItem';
import Tabs from '../components/Storyblok/tabber/Tabs';
import TableData from '../components/Storyblok/table/TableData';
import TableDataCell from '../components/Storyblok/table/TableDataCell';
import TableDataHeaderCell from '../components/Storyblok/table/TableDataHeaderCell';
import TableDataRow from '../components/Storyblok/table/TableDataRow';
import ProfileItem from '../components/Storyblok/team/ProfileItem';
import ProfileList from '../components/Storyblok/team/ProfileList';
import Team from '../components/Storyblok/team/Team';
import TeamCard from '../components/Storyblok/teamCard/TeamCard';
import TeamCardList from '../components/Storyblok/teamCard/TeamCardList';
import Testimonial from '../components/Storyblok/testimonials/Testimonial';
import Testimonials from '../components/Storyblok/testimonials/Testimonials';
import ThreeColumnsBlok from '../components/Storyblok/ThreeColumnsBlok';
import TileItem from '../components/Storyblok/tiles/TileItem';
import Tiles from '../components/Storyblok/tiles/Tiles';
import TwoColumnsBlok from '../components/Storyblok/TwoColumnsBlok';
import TwoColumnsTextWithImage from '../components/Storyblok/TwoColumnsTextWithImage';
import TwoColumnsTextWithImage2 from '../components/Storyblok/TwoColumnsTextWithImage2';
import TwoColumnsTextWithManyImages from '../components/Storyblok/TwoColumnsTextWithManyImages';
import TwoColumnsTitleText from '../components/Storyblok/TwoColumnsTitleText';
import TwoColumnsTitleTextCta from '../components/Storyblok/TwoColumnsTitleTextCta';
import TwoColumnsTitleTwoTexts from '../components/Storyblok/TwoColumnsTitleTwoTexts';
import TwoImagesLarge from '../components/Storyblok/TwoImagesLarge';
import Vacancies from '../components/Storyblok/vacancies/Vacancies';
import VideoWithTitleAndCta from '../components/Storyblok/VideoWithTitleAndCta';
import SingleColumnLogoAndText from '../components/Storyblok/SingleColumnLogoAndText';
import FullWidthImageWithOneColumnCaption from '../components/Storyblok/FullWidthImageWithOneColumnCaption';
import FullWidthImageWithTwoColumnCaption from '../components/Storyblok/FullWidthImageWithTwoColumnCaption';
import ProductCard from '../components/Storyblok/Product/ProductCard';
import ProductComparisonProductHighlights from '../components/Storyblok/Product/ProductComparisonProductHighlights';
import ProductComparisonProduct from '../components/Storyblok/Product/ProductComparisonProduct';
import ProductComparisonProductSpecificationList from '../components/Storyblok/Product/ProductComparisonProductSpecificationList';
import ProductSpecificationColorList from '../components/Storyblok/Product/ProductSpecificationColorList';
import ProductSpecificationDetails from '../components/Storyblok/Product/ProductSpecificationDetails';
import CartMessage from '../components/Storyblok/Cart/CartMessage';
import NewsletterSignup from '../components/Storyblok/newsletter/NewsletterSignup';

const components = {
  defaultPage: DefaultPage,
  header: Header,
  footer: Footer,
  page: DefaultPage,
  section: Section,
  media: Media,
  button: Button,
  link: Link,
  richText: RichText,
  video: Video,
  slider1: Slider1,
  slider1Item: Slider1Item,
  twoImagesLarge: TwoImagesLarge,
  twoColumnsTextWithImage: TwoColumnsTextWithImage,
  twoColumnsTitleText: TwoColumnsTitleText,
  twoColumnsTitleTwoTexts: TwoColumnsTitleTwoTexts,
  hero: Hero,
  FAQ,
  questions: Questions,
  promoteCategories: PromoteCategories,
  promoteCategoryItem: PromoteCategoryItem,
  newspapers: Newspapers,
  newspaper: Newspaper,
  testimonials: Testimonials,
  testimonial: Testimonial,
  featuredPost: FeaturedPost,
  post: Post,
  carouselPost: CarouselPost,
  support: Support,
  contact: Contact,
  twoColumnsTextWithImage2: TwoColumnsTextWithImage2,
  videoWithTitleAndCta: VideoWithTitleAndCta,
  largeImageWithTitleAndCta: LargeImageWithTitleAndCta,
  twoColumnsTextWithManyImages: TwoColumnsTextWithManyImages,
  team: Team,
  profileList: ProfileList,
  profileItem: ProfileItem,
  singleColumnTitleTextCta: SingleColumnTitleTextCta,
  singleColumnQuote: SingleColumnQuote,
  slider2: Slider2,
  slider2Item: Slider2Item,
  iconTextList: IconTextList,
  iconTextListItem: IconTextListItem,
  singleColumnTitleTextAccordion: SingleColumnTitleTextAccordion,
  accordionList: AccordionList,
  accordionItem: AccordionItem,
  vacancies: Vacancies,
  policy: Policy,
  policyItem: PolicyItem,
  tableData: TableData,
  tableDataHeaderCell: TableDataHeaderCell,
  tableDataRow: TableDataRow,
  tableDataCell: TableDataCell,
  businessPage: BusinessPage,
  businessHeader: BusinessHeader,
  businessFooter: BusinessFooter,
  twoColumnsTitleTextCta: TwoColumnsTitleTextCta,
  businessProductList: BusinessProductList,
  businessProductListItem: BusinessProductListItem,
  businessSupport: BusinessSupport,
  slider3: Slider3,
  slider3Item: Slider3Item,
  tabs: Tabs,
  tabItem: TabItem,
  postGrid: PostGrid,
  press: Press,
  mediaKitAccordionItem: MediaKitAccordionItem,
  mediaKit: MediaKit,
  shopProduct: ShopProduct,
  pdfViewer: PDFViewer,
  embeddedVideo: EmbeddedVideo,
  embeddedImage: EmbeddedImage,
  sectionHeader: SectionHeader,
  tiles: Tiles,
  tileItem: TileItem,
  slider4: Slider4,
  slider4Item: Slider4Item,
  teamCardList: TeamCardList,
  teamCard: TeamCard,
  twoColumnsBlok: TwoColumnsBlok,
  embeddedEventTime: EmbeddedEventTime,
  threeColumnsBlok: ThreeColumnsBlok,
  productDetailsSection: ProductDetailsSection,
  productDetailSlider: ProductDetailSlider,
  businessHero: BusinessHero,
  businessContact: BusinessContact,
  twoColumnProductHighlight: TwoColumnProductHighlight,
  singleColumnLogoAndText: SingleColumnLogoAndText,
  fullWidthImageWithOneColumnCaption: FullWidthImageWithOneColumnCaption,
  fullWidthImageWithTwoColumnCaption: FullWidthImageWithTwoColumnCaption,
  productCard: ProductCard,
  productComparisonProductHighlights: ProductComparisonProductHighlights,
  productComparisonProduct: ProductComparisonProduct,
  productComparisonProductSpecificationList: ProductComparisonProductSpecificationList,
  productSpecificationColorList: ProductSpecificationColorList,
  productSpecificationDetails: ProductSpecificationDetails,
  cartMessage: CartMessage,
  newsletterSignup: NewsletterSignup,
};

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';

storyblokInit({
  accessToken: process.env.GATSBY_STORYBLOK_ACCESSTOKEN,
  bridge: activeEnv !== 'production',
  use: [apiPlugin],
  components,
});

const StoryblokContext = React.createContext(null);

const StoryblokProvider = ({ children }) => (
  <StoryblokContext.Provider value={null}>{children}</StoryblokContext.Provider>
);

StoryblokProvider.propTypes = {
  children: PropTypes.any,
};

export default StoryblokProvider;
